/*eslint-disable no-unreachable */
import React from 'react'
import { Modal, Header, Button, Icon } from 'semantic-ui-react'
import {connect} from 'react-redux'

function mapStateToProps (state) {
   return {}
}

class TimemarkerComponent extends React.Component {
	render() {
		let left = (Math.round(1000 / this.props.timespan.seconds * (this.props.timestamp - this.props.timespan.start)) / 10) + '%'
		let time = new Date(this.props.timestamp * 1000);
		return (
			<div style={{
				height: '100%',
				minHeight: '1px',
				left: this.props['width-before'],
				right: this.props['width-after'],
				position: 'absolute',
				pointerEvents: 'none'
			}}>
				<div style={{
					position: 'absolute',
					left: left,
					top: '30px',
					width: '60px',
					marginLeft: '-30px',
					backgroundColor: '#FF0000',
					color: '#FFFFFF',
					borderRadius: '5px',
					padding: '2px 10px',
					textAlign: 'center'
				}}>{
					time.getHours().toString().padStart(2, '0')	
				}:{
					time.getMinutes().toString().padStart(2, '0')
				}</div>
				<div style={{
					width: '1px',
					borderLeft: '1px dotted #FF0000',
					top: '30px',
					zIndex: 10,
					position: 'absolute',
					bottom: '50px',
					left: left
				}}></div>
			</div>
		)
	}
};

export const Timemarker = connect(
  mapStateToProps
)(TimemarkerComponent)